import type { FetchArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import type { BaseQueryApi } from '@reduxjs/toolkit/query';

import { baseCMSQuery } from './base-cms-query';
import { baseQueryWithReauth, isUserNotFound } from './base-query-with-reauth';

export { isUserNotFound };

/**
 * This function uses the reauth logic from baseQueryWithReauth but with baseCMSQuery
 * for the initial and subsequent queries. This avoids duplicating the reauth logic.
 */
export async function baseCMSQueryWithReauth(
    args: string | FetchArgs,
    api: BaseQueryApi,
    extraOptions: {},
): Promise<Awaited<ReturnType<typeof baseCMSQuery>>> {
    // Use baseQueryWithReauth with baseCMSQuery as the query function
    return baseQueryWithReauth(args, api, extraOptions, baseCMSQuery);
}
